var _defs, _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gpage404",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wpage404",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83ADA9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83ADA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "opage404",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#F5F8F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wpage404)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#opage404)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 260,
    x2: 620,
    y2: 200,
    stroke: "#548A85",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 200,
    x2: 860,
    y2: 300,
    stroke: "#548A85",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 520,
    x2: 700,
    y2: 560,
    stroke: "#548A85",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 560,
    x2: 900,
    y2: 480,
    stroke: "#548A85",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 300,
    x2: 790,
    y2: 360,
    stroke: "#FF4804",
    strokeOpacity: 0.75,
    strokeWidth: 3,
    strokeDasharray: "10 12",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 470,
    x2: 420,
    y2: 520,
    stroke: "#FF4804",
    strokeOpacity: 0.75,
    strokeWidth: 3,
    strokeDasharray: "10 12",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 260,
    r: 17,
    fill: "url(#gpage404)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 200,
    r: 17,
    fill: "url(#gpage404)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 300,
    r: 26,
    fill: "#FF4804"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 520,
    r: 17,
    fill: "url(#gpage404)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 560,
    r: 17,
    fill: "url(#gpage404)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 480,
    r: 17,
    fill: "url(#gpage404)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage404);
export default __webpack_public_path__ + "static/media/page-404.4b8e30b207ead7b4e9f6e44c8bfba698.svg";
export { ForwardRef as ReactComponent };